import { Plus } from 'lucide-react';

interface Props {
    title: string;
    subtitle?: string;
    actionLabel?: string;
    onAction?: () => void;
}

export default function PageHeader({ title, subtitle, actionLabel, onAction }: Props) {
    return (
        <div className="mb-6 flex flex-col gap-4 sm:mb-8 sm:flex-row sm:items-end sm:justify-between">
            <div>
                <h1 className="font-[AvertaStd-Semibold] text-[26px] leading-tight text-ryd-headerTextPrimary sm:text-[32px]">
                    {title}
                </h1>
                {subtitle ? (
                    <p className="mt-1.5 max-w-xl text-[14px] leading-relaxed text-[#8b9aab] sm:text-[15px]">
                        {subtitle}
                    </p>
                ) : null}
            </div>
            {actionLabel && onAction ? (
                <button
                    type="button"
                    onClick={onAction}
                    className="inline-flex w-full shrink-0 items-center justify-center gap-2 rounded-[14px] bg-gradient-to-r from-[#7A2F78] via-ryd-primary to-[#E05AAE] px-5 py-3 text-[14px] font-semibold text-white shadow-md transition hover:scale-[1.02] hover:shadow-lg sm:w-auto"
                >
                    <Plus size={18} />
                    {actionLabel}
                </button>
            ) : null}
        </div>
    );
}
